// @ts-nocheck f2c377fd
import programsListWidget from './programsListWidget/programsListWidget';
import type { EditorAPI } from '#packages/editorAPI';

export default {
  getCategorySections(editorAPI: EditorAPI) {
    return {
      programsListWidget: programsListWidget({ editorAPI }),
    };
  },
};
